import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-navigation-minus-icon',
  templateUrl: './navigation-minus.component.html'
})
export class NavigationMinusComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
